/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ZipResponse
 */
export interface ZipResponse {
    /**
     * 
     * @type {string}
     * @memberof ZipResponse
     */
    base64EncodedZip: string;
}

/**
 * Check if a given object implements the ZipResponse interface.
 */
export function instanceOfZipResponse(value: object): value is ZipResponse {
    if (!('base64EncodedZip' in value) || value['base64EncodedZip'] === undefined) return false;
    return true;
}

export function ZipResponseFromJSON(json: any): ZipResponse {
    return ZipResponseFromJSONTyped(json, false);
}

export function ZipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'base64EncodedZip': json['base64EncodedZip'],
    };
}

  export function ZipResponseToJSON(json: any): ZipResponse {
      return ZipResponseToJSONTyped(json, false);
  }

  export function ZipResponseToJSONTyped(value?: ZipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base64EncodedZip': value['base64EncodedZip'],
    };
}

